import React from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';
import styled from 'styled-components';

import { BoxMessage, MESSAGE_TYPE } from '@components/Messages';

import messages from './messages';

const Container = styled.div`
  position: ${({ position }) => position};
  bottom: 0;
  z-index: 1;
`;
function NoLocationPointToast({
  open,
  onClose,
  onClick,
  intl: { formatMessage },
  position = 'fixed',
}) {
  return (
    open && (
      <Container position={position}>
        <BoxMessage
          type={MESSAGE_TYPE.INFO}
          title={formatMessage(messages.title)}
          message={formatMessage(messages.subtitle)}
          onClose={onClose}
          onCallToAction={onClick}
          actionLabel={formatMessage(messages.button)}
        />
      </Container>
    )
  );
}

NoLocationPointToast.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
  position: PropTypes.string,
};

export default injectIntl(NoLocationPointToast);
